import { useMemo, type Dispatch, type SetStateAction } from 'react';
import { InfinityScroll } from '../../components/InfinityScroll';
import ListWrapper from '../../components/ListWrapper';
import SortableTable from '../../components/SortableTable';
import { TableSkeleton } from '../../components/Skeleton';
import { getDocumentsTableColumns } from './documentsTableColumns';
import type { DocumentRecord } from './documentsTypes';

export interface DocumentsTableSectionProps {
  loading: boolean;
  hasNextPage: boolean;
  documents: DocumentRecord[];
  selectedIds: Set<string>;
  setSelectedIds: Dispatch<SetStateAction<Set<string>>>;
  loadMore: () => void;
  showUserColumn: boolean;
}

export function DocumentsTableSection({
  loading,
  hasNextPage,
  documents,
  selectedIds,
  setSelectedIds,
  loadMore,
  showUserColumn,
}: DocumentsTableSectionProps) {
  const columns = useMemo(() => getDocumentsTableColumns(showUserColumn), [showUserColumn]);

  if (loading && !documents.length) {
    return (
      <div className="px-4 py-5 sm:p-6">
        <TableSkeleton />
      </div>
    );
  }

  return (
    <ListWrapper items={documents}>
      <div className="overflow-hidden rounded-lg">
        <SortableTable
          storageId="documents"
          limitHeight={false}
          onChangeSelection={(selectedRows) => {
            setSelectedIds(selectedRows);
          }}
          selectedRows={selectedIds}
          setSelectedRows={setSelectedIds}
          columns={columns}
          data={documents}
          rowKey={(doc) => doc.id}
          rowClassName={(doc) => (selectedIds.has(doc.id) ? 'bg-gray-50 dark:bg-zinc-700' : '')}
        />

        <InfinityScroll
          onLoadMore={() => loadMore()}
          rootMargin="400px"
          enabled={hasNextPage && !loading}
        />
      </div>
    </ListWrapper>
  );
}
